import { render, staticRenderFns } from "./EditBundleDialog.vue?vue&type=template&id=8de5db96&"
import script from "./EditBundleDialog.vue?vue&type=script&lang=js&"
export * from "./EditBundleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports